import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveSupplierCategory } from './index';

// Api's
import { supplierCategoryApi } from '../../api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getSupplierCategorySaga() {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      supplierCategoryApi.getDomain
    );

    if (response.data.result) {
      yield put(saveSupplierCategory(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveSupplierCategory(null, true, resultError.messagesDataError));
    }
  }
}
